<template>
  <div>
    <div v-show="!showBundleEdit" ref="table_div" id="table_div">
      <vx-card id="selectShortCourseBundle" :title="'Select a bundle'" class="w-full mb-6">
        <vs-table ref="bundleList" stripe class="mt-3 vs-con-loading__container" single pagination @selected="handleSelectedBundle" :max-items="mainTableItemsPerPage" search :data="bundles">
          <div slot="header" class="vx-row flex flex-wrap-reverse items-center flex-grow">
      
          <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 vx-col s:w-1/3 xs:w-full sm:w-full md:w-1/3 lg:w-1/4 xl:w-1/6">
              <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
                <span class="mr-2">{{ mainTableCurrentPage * mainTableItemsPerPage - (mainTableItemsPerPage - 1) }} - {{ bundles.length - mainTableCurrentPage * mainTableItemsPerPage > 0 ? mainTableCurrentPage * mainTableItemsPerPage : bundles.length }} of {{ bundles.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/> 
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="mainTableItemsPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="mainTableItemsPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="mainTableItemsPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="mainTableItemsPerPage=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="mainTableItemsPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="mainTableItemsPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        
          <template slot="thead">
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="hours">Hours</vs-th>
            <vs-th sort-key="price">Price</vs-th>
            <vs-th sort-key="isAccredited">Accredited</vs-th>
            <vs-th >Logo</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :data="course" :key="indextr" v-for="(course, indextr) in data"> 
      
            <vs-td :data="data[indextr].name">
              {{ course.name }}
            </vs-td>

            <vs-td :data="data[indextr].hours">
              {{ course.hours }}
            </vs-td> 

            <vs-td :data="data[indextr].price">
              {{ `R ${course.price}` }}
            </vs-td> 

            <vs-td :data="data[indextr].isAccredited">
              <i :class="course.isAccredited ? 'icon feather icon-check' : 'icon feather icon-x'"></i>
            </vs-td> 

            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
      
    </div>
    <div v-show="showBundleEdit" ref="edit_div" id="edit_div"> 
      <vx-card id="addShortCourseBundle" :title="'Add Bundle'" class="w-full mb-6">
        <div class="short-course-content">
          <h5>{{`Selected bundle: `}} <strong>{{selectedBundle.name}}</strong></h5>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full">
              <div class="vx-col w-full mb-3">
                <label>Name</label>
                <vs-input autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full"  name="Name" v-model="formData.name" />
                <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
              </div>

              <div class="vx-col w-full">
                <label>Description</label>
                <vs-textarea autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full"  name="Description" v-model="formData.description" />
                <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description') }}</span>
              </div>

              <div class="vx-row w-full">
                <div class="vx-col sm:w-1/3 w-full">
                  <label>Hours</label>
                  <vs-input autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full"  name="Hours" v-model="bundleHours" />
                  <span class="text-danger text-sm" v-show="errors.has('Hours')">{{ errors.first('Hours') }}</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <label>Calculated Value</label>
                  <vs-input type="number" autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full"  name="Price" v-model="bundleValue" />
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <label>Price</label>
                  <vs-input type="number" autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full"  name="Price" v-model="formData.price" />
                  <span class="text-danger text-sm" v-show="errors.has('Price')">{{ errors.first('Price') }}</span>
                </div>
                <div class="vx-col mt-4 sm:w-1/2 w-full">
                  <vs-checkbox v-model="formData.isAccredited">Accredited</vs-checkbox>
                </div>
              </div>

            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <div class="vx-col w-full">
                <label>Logo</label>
                <file-pond
                  v-if="!formData.logoUrl"
                  id="filepond"
                  ref="Logopond"
                  :server="uploadLocation"
                  :name="'file'"
                  label-idle="Drop Bundle logo here or <span class='filepond--label-action'>Browse</span>"
                  :allow-multiple="false"
                  accepted-file-types="image/*,"
                  :instant-upload="true"
                  allowPaste=false
                  :allow-image-preview="false"
                  @processfile="uploadComplete"
                  @removefile="fileRemoved"
                />
                <vx-card class="logoCard w-full mb-2" v-if="formData.logoUrl" >
                  <div class="vx-row">
                    <p style="align-self:center;" class="ml-2 product-name font-medium">{{uploadedFileName(formData.logoUrl)}}</p>
                    <vs-spacer></vs-spacer>
                    <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" style="float:right!important"  @click.stop="removeFileButton('logoUrl')"></vs-button>
                  </div>
                </vx-card>
              </div>
              <div class="vx-col w-full">
                <label>Video</label>
                <file-pond
                  v-if="!formData.videoUrl"
                  id="videofilepond"
                  ref="Videopond"
                  :server="uploadLocation"
                  :name="'file'"
                  label-idle="Drop Intro Video here or <span class='filepond--label-action'>Browse</span>"
                  :allow-multiple="false"
                  accepted-file-types="video/*,"
                  :instant-upload="true"
                  allowPaste=false
                  :allow-image-preview="false"
                  @processfile="videoUploadComplete"
                  @removefile="fileRemoved"
                />
                <vx-card class="logoCard w-full mb-2" v-if="formData.videoUrl" >
                  <div class="vx-row">
                    <p style="align-self:center;" class="ml-2 product-name font-medium">{{uploadedVideoName(formData.videoUrl)}}</p>
                    <vs-spacer></vs-spacer>
                    <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" style="float:right!important"  @click.stop="removeFileButton('videoUrl')"></vs-button>
                  </div>
                </vx-card>
              </div>

              <div class="vx-col w-full">
                <label>Document</label>
                <file-pond
                  v-if="!formData.documentUrl"
                  id="documentfilepond"
                  ref="Documentpond"
                  :server="uploadLocation"
                  :name="'file'"
                  label-idle="Drop Bundle Document here or <span class='filepond--label-action'>Browse</span>"
                  :allow-multiple="false"
                  accepted-file-types="application/pdf,"
                  :instant-upload="true"
                  allowPaste=false
                  :allow-image-preview="false"
                  @processfile="documentUploadComplete"
                  @removefile="fileRemoved"
                />
                <vx-card class="logoCard w-full mb-2" v-if="formData.documentUrl" >
                  <div class="vx-row">
                    <p style="align-self:center;" class="ml-2 product-name font-medium">{{uploadedFileName(formData.documentUrl)}}</p>
                    <vs-spacer></vs-spacer>
                    <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" style="float:right!important"  @click.stop="removeFileButton('documentUrl')"></vs-button>
                  </div>
                </vx-card>
              </div>
            </div>
          </div>
          <div class="vx-row pb-3">
          </div>
          <div class="vx-row pb-3">
          </div>
        </div>
        
        <template>
          <vx-card :title="'Assign Shortcourse to Bundle'" class="w-full mb-6">
            <b-row style="display: flex;justify-content: space-between;">
              <b-form-group
                  class="mb-0"
                >
                <label class="d-inline-block text-sm-left mr-50">Per page</label>
                <b-form-select
                  id="perPageSelect"
                  v-model="tasksPerPage"
                  size="sm"
                  :options="pageOptions"
                  class="border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                />
              </b-form-group>
              <vs-button color="success" @click="loadPrerequisites()" type="filled" >Load shortcourses</vs-button>
              
            </b-row>
            <b-row>
              
              <!-- <b-col
                md="4"
                sm="8"
                class="my-1"
              >
                <b-form-group
                  label="Sort"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="sortBySelect"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-select
                      id="sortBySelect"
                      v-model="sortBy"
                      :options="sortOptions"
                      class="w-75"
                    >
                      <template v-slot:first>
                        <option value="">
                          -- none --
                        </option>
                      </template>
                    </b-form-select>
                    <b-form-select
                      v-model="sortDesc"
                      size="sm"
                      :disabled="!sortBy"
                      class="w-25"
                    >
                      <option :value="false">
                        Asc
                      </option>
                      <option :value="true">
                        Desc
                      </option>
                    </b-form-select>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                class="my-1"
              >
                <b-form-group
                  label="Filter"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="filterInput"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input
                      id="filterInput"
                      v-model="filter"
                      type="search"
                      placeholder="Type to Search"
                    />
                    <b-input-group-append>
                      <b-button
                        :disabled="!filter"
                        @click="filter = ''"
                      >
                        Clear
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->

              <b-col cols="12">
                <b-table
                  striped
                  hover
                  responsive
                  :per-page="tasksPerPage"
                  :current-page="currentTaskPage"
                  :items="notAssisgnedShortCourses"
                  :fields="unassignedTableFields"
                  class="mt-3 vs-con-loading__container"
                >
                <!-- :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered" -->
                  <!-- A virtual column -->
                  <template #cell(name)="data">
                    {{ data.item.name}}
                  </template>

                  <!-- A custom formatted column -->
                  <template #cell(hours)="data">
                    {{ data.item.hours }}
                  </template>

                  <!-- A custom formatted column -->
                  <template #cell(price)="data">
                    R{{data.item.price}}
                  </template>

                  <template #cell(accredited)="data">
                    <i :class="data.item.isAccredited ? 'icon feather icon-check' : 'icon feather icon-x'"></i>
                  </template>

                  <template #cell(assign_to_bundle)="data">
                    <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus" @click.stop.prevent="assignCourse(data.item.id)"></vs-button>
                  </template>
                </b-table>
              </b-col>

              <b-col
                cols="12"
              >
                <b-pagination
                  v-model="currentTaskPage"
                  :total-rows="totalRows"
                  :per-page="tasksPerPage"
                  align="center"
                  size="sm"
                  class="my-0"
                />
              </b-col>
              
            </b-row>
          </vx-card>
          
        </template>

        <template>
          <vx-card :title="'Assigned Shortcourses'" class="w-full mb-6">
            <b-row style="display: flex;justify-content: space-between;">
              <b-form-group
                class="mb-0"
              >
                <label class="d-inline-block text-sm-left mr-50">Per page</label>
                <b-form-select
                  id="perPageSelect"
                  v-model="tasksPerPage"
                  size="sm"
                  :options="pageOptions"
                  class="border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                />
              </b-form-group>
              <vs-button color="success" @click="clearPrerequisites()" type="filled" >Clear prerequisites</vs-button>
            </b-row>
            <b-row>
              
              <b-col
                md="2"
                sm="4"
                class="my-1"
              >
                
              </b-col>
              <b-col
                md="4"
                sm="8"
                class="my-1"
              >
                <!-- <b-form-group
                  label="Sort"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="sortBySelect"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-select
                      id="sortBySelect"
                      v-model="sortBy"
                      :options="sortOptions"
                      class="w-75"
                    >
                      <template v-slot:first>
                        <option value="">
                          -- none --
                        </option>
                      </template>
                    </b-form-select>
                    <b-form-select
                      v-model="sortDesc"
                      size="sm"
                      :disabled="!sortBy"
                      class="w-25"
                    >
                      <option :value="false">
                        Asc
                      </option>
                      <option :value="true">
                        Desc
                      </option>
                    </b-form-select>
                  </b-input-group>
                </b-form-group> -->
              </b-col>
              <b-col
                md="6"
                class="my-1"
              >
                <!-- <b-form-group
                  label="Filter"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="filterInput"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input
                      id="filterInput"
                      v-model="filter"
                      type="search"
                      placeholder="Type to Search"
                    />
                    <b-input-group-append>
                      <b-button
                        :disabled="!filter"
                        @click="filter = ''"
                      >
                        Clear
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group> -->
              </b-col>

              <b-col cols="12">
                <b-table
                  striped
                  hover
                  responsive
                  :per-page="tasksPerPage"
                  :current-page="currentTaskPage"
                  :items="assignedShortCourses"
                  :fields="tableFields"
                  class="mt-3 vs-con-loading__container"
                >
                <!-- :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered" -->
                  <!-- A virtual column -->
                  <template #cell(name)="data">
                    {{ data.item.name}}
                  </template>

                  <!-- A custom formatted column -->
                  <template #cell(hours)="data">
                    {{ data.item.hours }}
                  </template>

                  <!-- A custom formatted column -->
                  <template #cell(price)="data">
                    R{{data.item.price}}
                  </template>

                  <template #cell(accredited)="data">
                    <i :class="data.item.isAccredited ? 'icon feather icon-check' : 'icon feather icon-x'"></i>
                  </template>


                  <template #cell(unassign_to_bundle)="data">
                    <vs-button color="success" type="flat" icon-pack="feather" icon="icon-minus" @click.stop.prevent="unassignCourse(data.item.shortCourseId)"></vs-button>
                  </template>

                  
                  <template #cell(prerequisite)="data">
                    <b-form-select
                      v-model="data.item.prerequisiteShortCourseId"
                      :options="selectedShortCourses"
                    />
                  </template>

                  <template #cell(number)="data">
                    <div class="flex">
                      <vs-button color="dark" size="small" type="line" icon-pack="feather" line-origin="right" :disabled="data.item.number == 0"  icon="icon-arrow-up" @click="moveIndexUp(data.index)"></vs-button>
                      <vs-button color="dark" size="small" type="line" icon-pack="feather" line-origin="left" :disabled="getLastIndex(data.item.number)" icon="icon-arrow-down" @click="moveIndexDown(data.index)"></vs-button>
                    </div>
                  </template>
                </b-table>
              </b-col>
              
              <b-col
                cols="12"
              >
                <b-pagination
                  v-model="currentTaskPage"
                  :total-rows="totalRows"
                  :per-page="tasksPerPage"
                  align="center"
                  size="sm"
                  class="my-0"
                />
              </b-col>
              
            </b-row>
          </vx-card>
        </template>
        
        

        <div class="flex buttonArea w-full justify">
          <vs-button color="success" @click="saveBundle()" type="filled" >Save</vs-button>
          <vs-button class="ml-3" color="danger" @click="deleteBundle" type="filled" >Delete</vs-button>
          <vs-button color="warning" type="border" class="ml-3" @click="cancelAdd" >Cancel</vs-button>
        </div>
      </vx-card>
      
    </div>
  </div>
  
</template> 


<script>

import {
  BTable, BFormGroup, BFormRadio, BFormCheckbox, BFormRadioGroup, BCardBody,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import vueFilePond, {setOptions } from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

export default {
  data() {
    return {
      tableFields:['name','hours','price','accredited','unassign_to_bundle','prerequisite','number'], 
      unassignedTableFields : ['name','hours','price','accredited','assign_to_bundle'], 
      tasksPerPage:10,
      currentTaskPage:1,
      pageOptions: [10, 20, 30],
      totalRows:1,
      shortCourses:[],
      assignedShortCourses:[],
      notAssisgnedShortCourses:[],
      selectedShortCourses:[],
      bundleName:"",
      formData:{
          id:0,
          name:"",
          description:"",
          hours:0,
          price:0,
          logoUrl:"",
          videoUrl:"",
          documentUrl:"",
          isAccredited:false,
        },
      addBundleView:false,
      updateBundleView:false,
      showBundleEdit:false,
      chosenBundle:null,
      mainTableCurrentPage:1,
      mainTableItemsPerPage:10,
      bundles:[],
      selectedBundle:{}
    }
  },
  components:{ 
    vSelect,
    BTable,
    BFormGroup,
    BCardBody,
    vSelect,
    BFormRadio,
    BFormCheckbox,
    BFormRadioGroup,
  },
  watch:{ 
    assignedShortCourses: function(){
      var self = this;
      if(self.shortCourses){
        self.getSelectListPrerequisite();
      }
    }
  },
  computed: {
    server(){
      return {
        url: 'https://content.digicampus.co.za/scripts/',
        process: {
          url: 'tue4VGmEsLhfsy43X8WBemZ5UnTzLDuD2.php',
        },
      };
    }, 
    uploadLocation:{
        get() {
        return this.$buildUrl("tempupload");
      }
    },
    bundleHours:{
      get(){
        var self = this;
        var hours = 0;
        self.assignedShortCourses.forEach(element => {
          hours+= element.hours;
        });
        return hours;
      }
    },
    bundleValue:{
      get(){
        var self = this;
        var calculated = 0;
        self.assignedShortCourses.forEach(element => {
          calculated+= element.price;
        });
        return calculated;
      }
    }
  },
  methods: { 
    initValues(){
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.description = "";
      this.formData.hours = "";
      this.formData.price = "";
      this.formData.logoUrl = "";
      this.formData.videoUrl = "";
      this.formData.documentUrl = "";
      this.formData.isAccredited = false;
      this.moduleName = false;
      this.shortCourseList = [];
      this.tasksPerPage = 10;
      this.currentTaskPage = 1;
      this.updateBundleView = false;
      this.errors.clear();
      this.showBundleEdit = false;
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    cancelAdd(){
      this.showBundleEdit = false;
      this.initValues();
    },
    uploadComplete(error, file) {
      var response = JSON.parse(file.serverId);
      if(response.url)
        this.formData.logoUrl = response.url;
      this.clearFilepond("Logopond")
    },
    documentUploadComplete(error, file) {
      var response = JSON.parse(file.serverId);
      if(response.url)
        this.formData.documentUrl = response.url;
      this.clearFilepond("Logopond")
    },
    videoUploadComplete(error, file) {
      if(file.serverId)
        this.formData.videoUrl = file.serverId;
      this.clearFilepond("videoUrl")
    },
    fileRemoved(error, file) {
      this.formData.logoUrl = null;
    },
    clearFilepond(reference){
      var self = this;
      if(this.$refs[reference]){
        self.$refs[reference].getFiles().forEach(element => {
          self.$refs[reference].removeFile(element);
        });
      }
    },
    uploadedFileName(name){
      var self = this;
      if(name){
        var size = name.length;
        var firstIndex = name.split("_")[0].length +1;
        var file = name.substring(firstIndex,size);
        return file
      }
      else{
        return name
      }
    },
    uploadedVideoName(name){
      var self = this;
      if(name){
        var size = name.length;
        var firstIndex = name.split("g/")[0].length +2;
        var file = name.substring(firstIndex,size);
        return file
      }
      else{
        return name
      }
    },
    removeFileButton(file){
      var self = this;
      self.formData[file] = "";
      self.$vs.notify({
        title:'Information',
        color: "warning",
        text: "File Removed",
        position:'top-right',
        iconPack: 'feather',
        icon:'icon-trash',
      });
    },
    getShortCourses(){
      var self = this;
      self.showLoadingOnElement("edit_div",1,"corners");
      var onSuccess = response =>{
        self.shortCourses = response.data;
        self.notAssisgnedShortCourses = self.shortCourses;
        this.totalRows = response.data.length
      }
    
      var onFinally = response =>{
        if(self.$refs.edit_div){
          self.$vs.loading.close(self.$refs.edit_div.$el);
        }
      }
    
      self.$ajaxGet(self, "ShortCourse/ListShortCourses" , onSuccess, onFinally);
    },
    saveBundle(){
      var self = this;
      self.$validator.validateAll().then(result => {
        if(result){
          self.sendBundle();
        }
        else{
          self.$vs.notify({
            title: "Attention",
            color: "warning",
            text:  self.$validator.errors.items[0].msg,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info"
          });
          return;
        }
      });
    },
    sendBundle(){
      var self = this;
      var objectToSend = {
        id:self.selectedBundle.bundleId,
        bundleInformation:{
          name:self.formData.name,
          description:self.formData.description,
          hours:self.bundleHours,
          price:self.formData.price,
          logoUrl:self.formData.logoUrl,
          videoUrl:self.formData.videoUrl,
          documentUrl:self.formData.documentUrl,
          isAccredited:self.formData.isAccredited,
        },
        shortCourses:[

        ]
      };
      
      self.assignedShortCourses.forEach(element => {
        var courseObjectToAdd = {
          shortCourseId:element.shortCourseId,
          number:element.number,
          prerequisiteShortCourseId:element.prerequisiteShortCourseId
        }
        objectToSend.shortCourses.push(courseObjectToAdd);
      });

      self.showLoadingOnElement("edit_div",1,"corners");
      var onSuccess = response =>{
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Bundle Saved",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
        self.initValues();
        self.$router.push({ name: 'ShortCourseBundles'});
      }
    
      var onFinally = response =>{
        if(self.$refs.edit_div){
          self.$vs.loading.close(self.$refs.edit_div.$el);
        }
      }
      self.$ajaxPost(self, "Bundles/UpdateBundle" , objectToSend , onSuccess, onFinally);
    },
    getSelectListPrerequisite(){
      var self = this;
      var preRequisiteSelectList = [];
      preRequisiteSelectList.push({value:"0",text:"None"})
      self.assignedShortCourses.forEach(element => {
        preRequisiteSelectList.push({value:String(element.shortCourseId),text:element.name})
      });
      self.selectedShortCourses = preRequisiteSelectList;
    },
    assignCourse(id){
      var self = this;
      var course = self.shortCourses.filter(q=> q.id == id)[0];

      if(!self.assignedShortCourses.length){
        course.number = 0;
        self.assignedShortCourses.push(course);
      }else{
        self.assignedShortCourses.sort((a,b) => a.number - b.number);
        course.number = self.assignedShortCourses[self.assignedShortCourses.length - 1].number + 1;
        self.assignedShortCourses.push(course);
      }
      
      self.notAssisgnedShortCourses = self.shortCourses.filter(q=> !self.assignedShortCourses.includes(q));
    },
    unassignCourse(id){
      var self = this;
      self.assignedShortCourses = self.assignedShortCourses.filter(q=> q.shortCourseId != id);
      self.notAssisgnedShortCourses = self.shortCourses.filter(q=> !self.assignedShortCourses.includes(q));
      self.notAssisgnedShortCourses.forEach(q=> q.number = null);
    },
    clearPrerequisites(){
      var self = this;
      self.shortCourses.forEach(element => {
        element.prerequisiteShortCourseId = null;
      });
    },
    moveIndexUp(index){
      var self = this;
      if(index == 0){
        return;
      }
      var upperCourse = self.assignedShortCourses[index -1];
      var course = self.assignedShortCourses[index];
      course.number = course.number -1;
      upperCourse.number = upperCourse.number+1;

      self.assignedShortCourses.sort((a,b) => a.number - b.number);
    },
    moveIndexDown(index){
      var self = this;
      if(self.getLastIndex(index)){
        return;
      }
      var lowerCourse = self.assignedShortCourses[index +1];
      var course = self.assignedShortCourses[index];
      course.number = course.number +1;
      lowerCourse.number = lowerCourse.number-1;

      self.assignedShortCourses.sort((a,b) => a.number - b.number);
    },
    getLastIndex(index){
      var self = this;
      
      if(self.assignedShortCourses[self.assignedShortCourses.length - 1].number == index){
        return true;
      }
      return false;
    },
    getBundles(){
      var self = this;
      self.showLoadingOnElement("table_div",1,"corners");
      var onSuccess = response =>{
        self.bundles = response.data;
      }
    
      var onFinally = response =>{
        if(self.$refs.table_div){
          self.$vs.loading.close(self.$refs.table_div.$el);
        }
      }
    
      self.$ajaxGet(self, "Bundles/GetBundles" , onSuccess, onFinally);
    },
    handleSelectedBundle(bundle){
      var self = this;
      self.selectedBundle = bundle;
      self.showLoadingOnElement("table_div",1,"corners");
      var onSuccess = response =>{
        self.bundleInformation = response.data;
        self.formData = response.data.bundleInformation;
        self.assignedShortCourses = response.data.shortCourses;
        
        setTimeout(() => {
          self.showBundleEdit = true;
        }, 100);

        
      }
    
      var onFinally = response =>{
        if(self.$refs.table_div){
          self.$vs.loading.close(self.$refs.table_div.$el);
        }
      }
    
      self.$ajaxGet(self, `Bundles/GetBundle/${bundle.bundleId}` , onSuccess, onFinally);
    },
    loadPrerequisites(){
      var self = this;
      self.showLoadingOnElement("table_div",1,"corners");
      var onSuccess = response =>{
        self.shortCourses = response.data;

        self.shortCourses.forEach(element => {
          if(!self.assignedShortCourses.filter(q=> q.shortCourseId == element.id).length){
            if(!element.prerequisiteShortCourseId){
              element.prerequisiteShortCourseId = '0';
            }
            self.notAssisgnedShortCourses.push(element)
          }
        });
      }
    
      var onFinally = response =>{
        if(self.$refs.table_div){
          self.$vs.loading.close(self.$refs.table_div.$el);
        }
      }
    
      self.$ajaxGet(self, "ShortCourse/ListShortCourses" , onSuccess, onFinally);
    },
    deleteBundle(){
      var self = this;
      self.showLoadingOnElement("table_div",1,"corners");
      var onSuccess = response =>{
        self.$vs.notify({
          title:'Information',
          color: "warning",
          text: "Bundle Removed",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-trash',
        });
        self.initValues();
        self.getBundles();
      }
    
      var onFinally = response =>{
        if(self.$refs.table_div){
          self.$vs.loading.close(self.$refs.table_div.$el);
        }
        
      }
    
      self.$ajaxGet(self, `Bundles/DeleteBundle/${self.selectedBundle.bundleId}` , onSuccess, onFinally);
    },
  },
  mounted() { 
    var self = this;
    self.initValues();
    self.getBundles();
    //self.getShortCourses();
  },
}
</script>


<style lang="scss"> 

</style>